import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import ButtonFixedVoice from "../../ButtonFixedVoice"

import styles from "./styles.css"

import IconSearch from "../../../../../assets/svg/fixed_voice_dash_search.svg"

const InputSearch = ({
  searchTerm,
  handleSearch,
  placeholder,
  onSearch,
  className
}) => {
  return (
    <div className={classnames(styles.search_container, className)}>
      <div className={styles.align_search_button}>
        <img src={IconSearch} alt="Search" />
        <input
          type="text"
          className={styles.search_input}
          value={searchTerm}
          onChange={handleSearch}
          placeholder={placeholder}
        />
        <ButtonFixedVoice
          name={"Buscar"}
          onAction={onSearch}
          className={styles.buttonClass}
        />
      </div>
    </div>
  )
}

InputSearch.propTypes = {
  searchTerm: PropTypes.string,
  handleSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  onSearch: PropTypes.func,
  className: PropTypes.string
}

export default InputSearch



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/Inputs/InputSearch/index.js